import { DataTable } from "../../ui/data-table";
import { Heading } from "../../ui/heading";
import { Separator } from "../../ui/separator";
import { columns } from "./columns";

export const JobData: React.FC<any> = ({ data }) => {
  return (
    <>
      <div className="flex items-start justify-between">
        <Heading
          title={`Candidatures emplois (${data.length})`}
          description="Gestion des candidatures d'emplois"
        />
      </div>
      <Separator />
      <DataTable searchKey="title" columns={columns} data={data} />
    </>
  );
};
